<template>
    <div class="page-box">
        <h2 class="page-box-title">联系我们</h2>
        <div class="page-box-content">email：support@jzbill.com</div>
    </div>
</template>

<script>
    export default {
        name: "Contact"
    }
</script>

<style scoped>

</style>
